const fonts = `
  li {
    background: black;
  }
`;

const starVars = '#000';

const Wrapper = `
  border:1px solid #ddd;
  border-radius: 0 3px 3px 3px;
  background: #fff;
  padding: 10px;
  transition: ease all .3s;
  & > *{
    transition: ease all .3s;
    &:last-of-type{
      margin-bottom:0px;
    }
  }
`;

const tabs = `
  border-bottom: 0px solid !important;
  [role="button"] {
    background: #f5f5f5;
    padding: 5px 10px;
    color:#333;
    border-right:1px solid #ddd;
    border-left:1px solid #ddd;
    border-top: 5px solid #ddd !important;
    border-bottom: 1px solid #ddd;
    &:hover, &:focus{
      background: #fff;
      padding: 5px 10px;
      color:#333;
      border-right:1px solid #ddd;
      border-left:1px solid #ddd;
      border-top: 5px solid #ddd !important;
      border-bottom: 1px solid #ddd;
    }
  }
  &:not(:last-of-type){
    [role="button"] {
      margin-right:5px;
    }
  }
  &.active{
    [role="button"] {
      background: #fff;
      padding: 5px 10px;
      color:#333;
      border-right:1px solid #ddd;
      border-left:1px solid #ddd;
      border-top: 5px solid #2991d1 !important;
      border-bottom: 1px solid #fff;
      &:hover, &:focus{
        background: #fff;
        padding: 5px 10px;
        color:#333;
        border-right:1px solid #ddd;
        border-left:1px solid #ddd;
        border-top: 5px solid #2991d1 !important;
        border-bottom: 1px solid #fff;
      }
    }
    &:not(:last-of-type){
      [role="button"] {
        margin-right:5px;
      }
    }
  }
`;

const theme = {
  color: starVars,
  background: "black",
  fontSize: "60px",
  tab: {
    border: "1px solid"
  },
  fonts,
  tabs,
  Wrapper
};

export { theme, theme as default };
